import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class LocalAssetReaderService {
  constructor(private httpClient: HttpClient) {}

  async getContent(filePath: string) {
    return this.httpClient.get(filePath, { responseType: 'text' }).toPromise();
  }
}
